import React from 'react';

const BeachIcon = (props) => {
  return (
    <img
      alt="Plaża"
      src="/static/images/icons/place_types/beach.svg"
      {...props}
    />
  );
};

export default BeachIcon;
